<template>
  <div class="width-100">
    <div class="action-buy width-100">
      <button aria-label="Detalhes" id="buy-button" class="btn primary-button width-100" @click="goToProduct()">
        <i class="fa fa-external-link-square"></i> Detalhes
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsButton',
  props: ['url'],
  methods: {
    goToProduct() {
      window.location = this.url
    },
  }
}
</script>
